let oneColumnSwitcher = document.querySelector('.two-columns');
  let twoColumnSwitcher = document.querySelector('.one-column');
  let gridItem = document.getElementById('AjaxinateContainer');

  oneColumnSwitcher.addEventListener("click", function(e){
    twoColumnSwitcher.classList.remove('active');
    gridItem.classList.remove('grid-two-column');
    oneColumnSwitcher.classList.add('active');
    gridItem.classList.add('grid-one-column');
    if(document.documentElement.scrollTop > 4000) {
      document.documentElement.scrollTop = document.body.scrollTop = 1000;
    }
    localStorage.setItem("buttonActive", "1");
  });

  let isButtonActive = localStorage.getItem("buttonActive");
  if(isButtonActive == "1"){
    oneColumnSwitcher.classList.add('active');
    gridItem.classList.add('grid-one-column');
  };

  twoColumnSwitcher.addEventListener("click", function(e){
    oneColumnSwitcher.classList.remove('active');
    gridItem.classList.remove('grid-one-column');
    gridItem.classList.add('grid-two-column');
    twoColumnSwitcher.classList.add('active');
    localStorage.setItem("buttonActive", "2");
  });

    if(isButtonActive == "2"){
      twoColumnSwitcher.classList.add('active');
      gridItem.classList.add('grid-two-column');
    }; 

    window.addEventListener("scroll", function(e){
    let drawerCart = document.querySelector(".cart-drawer");
    let announcementBar = document.querySelector(".announcement-bar__item");
    let notVisible = "";
    if(announcementBar){
      let notVisible = announcementBar.offsetTop;
    }
    

    if(notVisible != ""){
      if (window.pageYOffset > notVisible) {
          drawerCart.classList.add("not-visible");
      } else {
          drawerCart.classList.remove("not-visible");
      }
    }
  });

  let mobileFilterTitle = document.querySelectorAll('.filters-mobile-icon');
  let mobileFilters = document.querySelector('.mofile-filters-form');
  let collectionSidebar = document.querySelector(".collection-sidebar-filters");
  let mobileFiltersWrapper = document.querySelector(".mobile-filters-wrapper");
  let mobileSortBy = document.querySelector('.mobile-sort-form');
  let bagButton = document.querySelectorAll('.product-item__bag-icon');

  mobileFilterTitle.forEach(function(mobileFilterTitle) {
    mobileFilterTitle.addEventListener("click", function(e) {
      mobileFilters.classList.add('active');
      collectionSidebar.style.position = "initial"
      document.querySelector('.overlay').classList.add("active");
      document.querySelector('.overlay').style.zIndex = "999";
      document.body.classList.add('lock');
      mobileFiltersWrapper.style.position = 'inherit';
    });
  });

  document.querySelector('.overlay').addEventListener("click", function(e){
    document.querySelector('.overlay').style.zIndex = "124";
    mobileFilters.classList.remove('active');
  });

  window.addEventListener('load', function() {
    const oneColumnDiv = document.querySelector('.one-column');
    const twoColumnsDiv = document.querySelector('.two-columns');

    if (!oneColumnDiv.classList.contains('active')) {
        // If not, then add the 'active' class to 'two-columns'
        twoColumnsDiv.classList.add('active');
      }
    });
  
    function changeGrid(className) {
      const activeDiv = document.querySelector('.active');
      if (activeDiv && activeDiv.classList.contains(className)) {
        // If the clicked div is already active, do nothing.
        return;
      }
  
      const allDivs = document.querySelectorAll('.chage-list > div');
      for (const div of allDivs) {
        if (div.classList.contains(className)) {
          // Remove 'active' class from any previously active div.
          div.classList.add('active');
        } else {
          div.classList.remove('active');
        }
      }
    }

  function changeGrid(val){
    let oneColumnSwitcher = document.querySelector('.two-columns');
    let twoColumnSwitcher = document.querySelector('.one-column');
    let gridItem = document.getElementById('AjaxinateContainer');
    if(val == 'one-column'){
      oneColumnSwitcher.classList.remove('active');
      gridItem.classList.remove('grid-one-column');
      gridItem.classList.add('grid-two-column');
      twoColumnSwitcher.classList.add('active');
      
    } else if(val == 'two-columns'){
      twoColumnSwitcher.classList.remove('active');
        gridItem.classList.remove('grid-two-column');
        oneColumnSwitcher.classList.add('active');
        gridItem.classList.add('grid-one-column');
        if(document.documentElement.scrollTop > 4000) {
          document.documentElement.scrollTop = document.body.scrollTop = 1000;
        }
    }
  }

  let underline_iterate = 0;
  function underlineFilter(filter) {
    let allItems = document.querySelectorAll('.filter-item__content');
    for(var a = 0; a < allItems.length; a++){
      if(allItems[a].style.textDecoration == "underline"){
        allItems[a].style.textDecoration = "";
        allItems[a].querySelector(".filter-item__label").style.fontWeight = 600;
        allItems[a].querySelector(".filter-item__count").style.fontWeight = 600;
      }
    }
    let currentItem = "filter-" + filter;
    underline_iterate = underline_iterate + 1;
    let currentItemId = document.getElementsByClassName(currentItem);
    let allTag = document.querySelectorAll('.collections-all');
    if(underline_iterate % 2 == 0){
      for(var i = 0; i < currentItemId.length; i++){
        if(!currentItemId[i].style.textDecoration){
          currentItemId[i].style.textDecoration = "underline";
          currentItemId[i].querySelector(".filter-item__label").style.fontWeight = 900;
          currentItemId[i].querySelector(".filter-item__count").style.fontWeight = 900;
          for(var j = 0; j < allTag.length; j++){
            allTag[j].style.fontWeight = 600;
            allTag[j].style.textDecoration = "none";
          }
        } else {
          currentItemId[i].style.textDecoration = "";
          currentItemId[i].querySelector(".filter-item__label").style.fontWeight = 600;
          currentItemId[i].querySelector(".filter-item__count").style.fontWeight = 600;
          for(var j = 0; j < allTag.length; j++){
            allTag[j].style.fontWeight = 900;
            allTag[j].style.textDecoration = "underline";
          }
        }
      }
    }
  }